module.exports = __webpack_public_path__ + "static/media/cb-tab.846ea06d.png";